import { Col, Row } from "react-bootstrap";
import '../../css/home/app-card.scss'

const AppCardW = ({svg, header, description}:any) => (
  <Col>
    <Row>
      <Col sm={2} className="d-flex align-content-start">
        <div className="cardImg">
          <img src={svg} alt="icon" />
        </div>
      </Col>
      <Col sm={10}>
        <h6 className="text-start">{header}</h6>
        <p className="text-start"> {description}</p>
      </Col>
    </Row>
 </Col>
)

export default AppCardW;